import { getGCLIDParameters } from 'domains/tracking/GCLIDtracking';
import { getUTMParameters } from 'domains/tracking/UTMTracking';
import { DirectSignupFilters } from '../../context';
import { buildUrl } from 'utils/url';
import { JotformRedirectReason, JOTFORM_REASON_URL_MAP, SIGNUP_JOTFORM_URLS } from './urls';

export const getJotformRegistrationFormLink = ({
  filters,
  leadId,
  reason,
}: {
  filters: DirectSignupFilters;
  leadId?: string;
  reason: JotformRedirectReason;
}) => {
  const baseUrl = SIGNUP_JOTFORM_URLS[JOTFORM_REASON_URL_MAP[reason]];
  const state = filters.stateCode;
  const pid = filters.paymentMethod.type === 'insurance' ? filters.paymentMethod.insuranceData.entryId : '';
  const GClid = getGCLIDParameters();
  const UTMParams = getUTMParameters();

  const queryParams = {
    state,
    pid: pid,
    leadID: leadId,
    gclid: GClid?.gclidTracker,
    origin: reason,
    ...UTMParams,
  };

  return buildUrl(baseUrl, queryParams);
};
